const columns = [
  {
    name: 'Name',
    selector: (row) => row.name,
  },
  {
    name: 'Company',
    selector: (row) => row.company,
  },
  {
    name: 'Logo',
    selector: (row) => <>
      <h2 className="flex items-center">
        <img
          src={row.logo}
          className="w-32 h-16 p-4"
        />
      </h2>
    </>,
  },
  {
    name: 'Actions',
    selector: (row) => row.actions,
  },
]

export default columns
